export default [{
  path: '/staffWorkType',
  name: 'staffWorkType',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/staffWorkType/index')
}]
